export default {
    nav: {
        home: '首页',
        products: '产品',
        solutions: '解决方案',
        support: '服务支持',
        aboutUs: '关于我们',
        contact: '联系我们'
    },
    hero: {
        title: '酷壹智能<br>一站式智慧空间与安防报警解决方案商',
        desc: '让空间更智能、更安全、更安心。'
    },
    protocol: {
        title: '通讯协议',
        cards: {
            zigbee: 'Zigbee 3.0是由连接标准联盟（CSA）推出的统一无线通信标准，通过整合碎片化的应用协议实现跨品牌智能设备的无缝互操作与低功耗Mesh组网。',
            wifi: 'Wi-Fi是一种全球通用的无线网络技术，通过无线电波传输数据，允许设备在无需物理电缆的情况下接入网络。',
            rf433: '433MHz是一种低频无线电波频段，常用于安防报警系统、智能开关等短距离、低功耗设备。',
            modbus: 'Modbus是一种广泛应用于工业自动化领域的串行通信协议，支持主从站通信和数据交换。',
            knx: 'KNX是一种欧洲标准的总线技术，广泛应用于智能建筑的楼宇自动化系统。',
            bluetooth: '蓝牙是一种用于设备间通信的无线通信技术，广泛应用于智能酒店、智能家居等领域。'
        }
    },

    // 新增的应用场景部分
    services: {
        title: '应用场景',
        features: {
            smartHome: {
                title: '智能家居',
                desc: '打破传统家居局限，打造全场景智慧生活空间，支持Zigbee、Wi-Fi等多种协议，使设备互联互通、场景随心切换，用极简操作解锁高效便捷生活，以科技温度提升居住幸福感，让家更懂你，让生活更有质感。'
            },
            security: {
                title: '智慧安防',
                desc: '安防报警主机搭配专业监控平台，构建一体化安全防控体系。报警主机作为系统核心，通过433MHz协议接入红外、烟感、紧急按钮等各类探测器，实现入侵、火情、紧急求助等多场景实时告警。'
            },
            hotel: {
                title: '智慧酒店',
                desc: '以物联网为核心，搭配酒店设备管理平台，打通智能客房、前台管理、房间服务管理等业务场景，为住客与酒店方带来双重价值。'
            },
            building: {
                title: '楼宇自动化',
                desc: '基于RTU，通过管理后台配置，支持Modbus设备接入，轻松实现楼宇设备的集中监控、智能控制与能耗管理，让传统建筑智能化升级。'
            }
        }
    },

    // 新增的软件平台部分
    software: {
        title: '软件与平台',
        steps: {
            cms: { title: '接警中心', desc: '点击跳转' },
            kooyii: { title: '酷壹', desc: '鼠标移入，扫码下载' },
            elderly: { title: '智慧养老', desc: '暂未开放体验，更多详情请联系销售人员' },
            hotel: { title: '智慧酒店', desc: '暂未开放体验，更多详情请联系销售人员' },
            building: { title: '楼宇自动化', desc: '暂未开放体验，更多详情请联系销售人员' },
            more: { title: '更多应用场景', desc: '请联系销售人员获取专业意见' }
        }
    },
    solutions: {
        services: {
            title: '我们的服务',
            features: {
                hardware: {
                    title: '硬件定制',
                    desc: '从核心 PCBA 电路板到整机外观结构的一站式专属设计制造服务，覆盖电路方案、元器件选型、PCB Layout、功能调试，以及外壳开模、材质工艺、结构防护等全流程。'
                },
                software: {
                    title: '软件定制',
                    desc: '根据您的实际业务需求，量身打造专属应用与网页系统的开发服务，涵盖移动端 App（iOS/Android）、及 PC 端网页、管理后台等。为您提供更高效、更贴合自身运营模式的数字化解决方案。'
                },
                server: {
                    title: '私有化部署',
                    desc: '将系统、平台或应用完整搭建在客户自有服务器或指定内网环境中的部署方式，数据与服务完全独立运行，实现系统自主可控。'
                }
            }
        },
        whyUs: {
            title: '为什么选择我们？',
            benefits: {
                oneStop: {
                    title: '一站式服务',
                    desc: '我们的解决方案涵盖了软件和硬件，全流程统一对接，无需多方协调，缩短开发周期，减少沟通成本。'
                },
                custom: {
                    title: '深度定制',
                    desc: '软件功能与硬件性能精准匹配，避免兼容性问题，整体运行更流畅、故障率更低。'
                },
                expandable: {
                    title: '强拓展性',
                    desc: '我们的服务预留拓展接口与服务，方便客户后续根据需求进行功能升级与扩展。'
                },
                deployment: {
                    title: '灵活部署',
                    desc: '无论是本地化私有部署还是公有云部署，我们都提供灵活的方案以满足您的需求。'
                }
            }
        },
        cta: {
            title: '准备好升级您的生活方式了吗？',
            desc: '今天就与我们的智能家居专家交流，让我们为您设计完美的生态系统。',
            button: '联系销售'
        }
    },
    product: {
        nav: {
            panel: '中控屏',
            hub: '智能网关',
            switch: '智能开关',
            curtain: '窗帘',
            sensor: '传感器',
            lighting: '智能照明',
            security: '智能安防',
            doorlock: '智能门锁'
        },
        sub: {
            '4inch': '4 英寸',
            '5inch': '5 英寸',
            '6inch': '6 英寸',
            '7inch': '7 英寸',
            '8inch': '8 英寸',
            '10inch': '10 英寸',
            '1gang': '1 路',
            '2gang': '2 路',
            '3gang': '3 路',
            '4gang': '4 路',
            'openclose': '开合帘',
            'roller': '卷帘',
            'downlight': '筒射灯',
            'magnetic': '磁吸灯',
            'strip': '灯带',
            'alarm': '报警主机',
            'door': '门磁',
            'smoke': '烟雾传感器',
            'infrared': '红外探测器',
            'radar': '人体存在雷达',
            'water': '水浸传感器',
            'temp': '温湿度传感器',
            'indoorCam': '室内摄像头',
            'outdoorCam': '室外摄像头',
            'password': '密码锁',
            'fingerprint': '指纹锁',
            'face': '人脸锁'
        },
        common: {
            learnMore: '了解更多',
            addToCart: '加入购物车',
            buyNow: '立即购买',
            emptyProduct: '暂无相关产品，敬请期待...'
        },
        cart: {
            titleList: '申请清单',
            titleForm: '填写联系信息',
            empty: '清单为空，快去添加产品吧',
            delete: '删除',
            totalItems: '共选中 {count} 件产品',
            nextStep: '下一步：填写信息',
            submit: '提交申请'
        },
        form: {
            name: '怎么称呼您',
            namePlaceholder: '请输入您的姓名',
            address: '公司地址',
            addressPlaceholder: '请输入公司详细地址',
            location: '城市 / 国家',
            locationPlaceholder: '例如：北京，中国',
            whatsapp: 'WhatsApp',
            whatsappPlaceholder: '请输入您的WhatsApp以便我们能联系您',
            email: '邮箱',
            emailPlaceholder: '请输入您的邮箱以便我们能联系您',
            remark: '备注',
            remarkPlaceholder: '请输入您的备注以便我们能更好地了解您的需求'
        },
        alert: {
            fillRequired: '请填写必填项（带有 * 号的字段）',
            submitSuccess: '申请已提交成功！我们的销售人员会尽快与您联系。'
        }
    },
    contact: {
        hero: {
            title: '联系我们',
            desc: '您将获得专业的意见与最适合的方案'
        },
        form: {
            title: '在线留言',
            subtitle: '请填写下方表单，我们将在 24 小时内与您联系。',
            firstName: '名',
            firstNamePlaceholder: '例：三',
            lastName: '姓',
            lastNamePlaceholder: '例：张',
            email: '工作邮箱',
            emailPlaceholder: "zhangsan{'@'}company.com",
            inquiryType: '咨询类别',
            selectTopic: '请选择一个主题...',
            message: '留言内容',
            messagePlaceholder: '请问有什么我们可以帮到您？',
            submitBtn: '发送留言',
            sending: '发送中...',
            successMsg: '感谢您的留言！您的信息已成功发送。'
        },
        inquiry: {
            general: '一般咨询',
            sales: '销售与渠道合作',
            support: '技术支持',
            hardware: 'OEM/ODM',
        },
        location: {
            title: '我们在哪里',
            officeName: '深圳总部',
            address: '中国广东省深圳市龙华区大浪街道陶元社区联润路凯立方广场1栋1单元603',
            phone: '+86 18926403313 袁小姐'
        }
    },
    footer: {
        companyName: '深圳市金安科技有限公司'
    }
}